import { render, staticRenderFns } from "./AccountSettingBrands.vue?vue&type=template&id=237bc986&"
import script from "./AccountSettingBrands.vue?vue&type=script&lang=js&"
export * from "./AccountSettingBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports